import { ActiveFiltersType, StickersType } from '@bytel/product-wall';
import { countActiveFilters } from '@bytel/product-wall/helpers';
import { FilterTypeEnum } from '@bytel/product-wall/types';

import { cmsService } from '@services/cms';
import { getWallConfig } from '@services/config';
import { httpService } from '@services/http';
import { HttpService } from '@services/http/http';

import { WallConfigType, WallType } from '@app-types/config';

import { isServer } from '@helpers/config';
import { localApiPaths } from '@helpers/path';

class StickersService {
    private httpService: HttpService;
    private config: WallConfigType;

    public constructor(httpService: HttpService) {
        this.httpService = httpService;
        this.config = getWallConfig(WallType.PHONE);
    }

    public async get(
        activeFilters: ActiveFiltersType,
        isRenewal: boolean = false,
        search: string | null,
    ): Promise<StickersType> {
        if (isServer()) {
            return this.getStickersServer(activeFilters, isRenewal, search);
        }

        return this.httpService
            .get<StickersType>(localApiPaths.stickers, {
                activeFilters: JSON.stringify(activeFilters),
                isRenewal,
                search: search,
            })
            .catch(() => {
                return { products: [], count: 0 };
            });
    }

    private async getStickersServer(
        activeFilters: ActiveFiltersType,
        isRenewal: boolean,
        search: string | null,
    ): Promise<StickersType> {
        const activeFiltersCount = countActiveFilters(activeFilters);

        if (search) {
            return {};
        }

        const genericSliderUrl: string = isRenewal ? 'stickers-mdt-rnw' : 'stickers-mdt-acq';
        let url = genericSliderUrl;

        if (activeFiltersCount >= 1) {
            const entries = Object.entries(activeFilters);
            const urlKeys: string[] = [];

            for (const [key, value] of entries) {
                const filter = this.config.filtersObject[key];
                let urlKey: string | undefined;

                if (filter?.type === FilterTypeEnum.CHECKBOX_LIST) {
                    urlKey = Object.values(filter.values ?? {}).find((v) => v.value === value[0])?.urlKey;
                } else if (filter?.type === FilterTypeEnum.CHECKBOX) {
                    urlKey = filter.urlKey;
                }

                if (urlKey) {
                    urlKeys.push(urlKey);
                }
            }

            url = urlKeys.length > 0 ? `${genericSliderUrl}-${urlKeys.join('-')}` : genericSliderUrl;
        }

        try {
            return await this.getStickersList(url);
        } catch {
            return {};
        }
    }

    private async getStickersList(url: string) {
        return cmsService.getStickers(url);
    }
}

export const stickersService = new StickersService(httpService);
